import { gql } from "@apollo/client";

export const GET_FILTERS = gql`
  query GetFilters($game: Game!) {
    filters: clipFilters(game: $game) {
      description
      key
      options {
        description
        value
      }
    }
  }
`;
